


















































import {Vue, Component, Prop, Watch} from "vue-property-decorator";
import Table from '@share/ticketSystem/components/table-list/Table.vue';
import TicketEdit from '@share/ticketSystem/components/TicketEdit.vue';
import TicketCreate from '@share/ticketSystem/components/TicketCreate.vue';
import {TicketService} from "@share/common/services/ticket/TicketService";
import { TableViewParams } from "@common/table/interfaces/ViewParams";
import {TicketType} from "@share/ticketSystem/enums/TicketTypes";
import ATableRow from "@share/ticketSystem/components/table-list/TableRow.vue";
import {RouteNamesEnum} from "@service/router/RouteNamesEnum";
import { UserProfile } from "@api/models/UserProfile";
import { TicketTableHelper } from "@share/ticketSystem/helpers/TicketTableHelper";
import SegmentControl from  "@share/common/segment/Segment.vue";
import TicketView from '@share/ticketSystem/components/TicketView.vue';
import TicketsReports from "@share/ticketSystem/components/reports/TicketsReports.vue"


@Component({
    components: {Table, TicketEdit, ATableRow, TicketView, TicketCreate, SegmentControl, TicketsReports}
})

export default class TicketSystemRoot extends Vue {
    @Prop({required: true}) ticketsType: TicketType;
    @Prop({required: true}) ticketService: TicketService;
    @Prop({required: true}) ticketHelper: TicketTableHelper;
    @Prop({ required: true }) isAdmin: boolean;

    users: { [key: string]: UserProfile } = {};
    onlyOwn = false;
    viewedTicket: string | null = '';
    showReports = false;

    tableViewParams: TableViewParams = {
        scrollPosition: undefined
    }

    saveScrollPosition() {
        this.tableViewParams.scrollPosition = (this.$refs["table"] as Table | undefined)?.getTableScrollPosition() || 0;
    }

    closeViewTicket() {
        const toRoute = this.$route.name === RouteNamesEnum.ticketSystemIdeaView
            ? RouteNamesEnum.ticketSystemIdeas : RouteNamesEnum.ticketSystemProblems;
        if (toRoute) {
            this.$router.push({
                name: toRoute,
                hash: this.$route.hash
            })
        }
    }

    changeTicketSet(value: boolean) {
        this.onlyOwn = value;
        this.ticketHelper.setOnlyOwn(value);
    }

    @Watch('ticketsType', { immediate: true })
    watchRoute(value: TicketType) {
        if(value === TicketType.idea) {
            this.$store.dispatch("setPageTitle", this.$t("common.ticketSystemIdeas"));
        }
        else {
            this.$store.dispatch("setPageTitle", this.$t("common.ticketSystemProblems"));
        }
    }

    get isViewTicket() {
        if (this.$route?.name) {
            return [
                RouteNamesEnum.ticketSystemIdeaView.toString(),
                RouteNamesEnum.ticketSystemProblemView.toString()
            ].includes(this.$route.name);
        }
        return false;
    }

    get params() {
        return {
            ticketsType: this.ticketsType,
            ticketService: this.ticketService,
            ticketHelper: this.ticketHelper,
            onlyOwn: this.onlyOwn
        }
    }

    get ticketId() {
        if (this.$route.params && this.$route.params.id) {
            return this.$route.params.id;
        }
        return null;
    }

    get isRouteForCreateTicket() {
        return this.$route.name === RouteNamesEnum.ticketSystemProblemCreate ||
            this.$route.name === RouteNamesEnum.ticketSystemIdeaCreate;
    }

    get segmentData()  {
        return [{
            active: !this.onlyOwn,
            title: this.$t('tickets.allTickets'),
            value: false
        },
        {
            active: this.onlyOwn,
            title: this.$t('tickets.ownTickets'),
            value: true
        }]
    }

    createTicket() {
        const toRoute = this.$route.name === RouteNamesEnum.ticketSystemIdeas
            ? RouteNamesEnum.ticketSystemIdeaCreate : RouteNamesEnum.ticketSystemProblemCreate;
        this.$router.push({
            name: toRoute,
            hash: this.$route.hash
        });
    }
}
